import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Input, Button } from 'antd';
import SearchRetrieve from '../common/SearchRetrieve';
import SelectProvince from '../common/SelectProvince';
import TableC from '../basicElement/TableC';
import $ from '../../common/AjaxRequest';
import API_URL from '../../common/url';
import UserSider from './UserSider';
import { saveParams } from '../../actions/PersonalActions';

class Filter extends Component {
    state = {
        searchParams: {
            workStatus: 'WORKING',
        },
    }

    componentDidMount() {
        this.search();
    }

    search = () => {
        const {
            searchParams,
            searchParams: {
                areaParams,
            },
        } = this.state;
        this.props.search({ ...searchParams, ...areaParams, areaParams: '', hasCheckedArea: '' });
    }

    enterSearch = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    handleDateChange = (data, dateString, field) => {
        const { searchParams } = this.state;
        searchParams[field] = dateString;
        this.setState({ searchParams });
    }

    handleInputChange = (e, field) => {
        const { searchParams } = this.state;
        searchParams[field] = e.target.value;
        this.setState({ searchParams });
    }

    handleSelectChange = (value, field) => {
        const { searchParams } = this.state;
        searchParams[field] = value;
        this.setState({ searchParams });
    }

    saveProvince = (checkedArea) => {
        const { searchParams } = this.state;
        const areaParams = {};
        checkedArea.map(item => {
            areaParams[`params[${item.props.title}]`] = item.key;
        });
        const areaList = checkedArea.map(item => item.props.title);
        const hasCheckedArea = checkedArea.map(item => item.key);
        this.setState({
            searchParams: {
                ...searchParams,
                areaParams,
                hasCheckedArea,
                areaName: areaList.join(','),
            }
        });
    }

    handleChange = (type, value, options, isLoading) => {
        const { searchParams } = this.state;
        const { key, label } = value || {};
        const obj = {};
        if (type === 'department') {
            searchParams.enterpriseDepartmentId = key;
            searchParams.enterpriseDepartmentName = label;
            searchParams.positionId = '';
            searchParams.positionName = '';
            obj.departmentOptions = options;
            obj.positionOptions = [];
        } else if (type === 'xjDept') {
            searchParams.xjDeptId = key;
            searchParams.xjDeptName = label;
            obj.xjDeptOptions = options;
        } else if (type === 'xxjDept') {
            searchParams.xxjDeptId = key;
            searchParams.xxjDeptName = label;
            obj.xxjDeptOptions = options;
        } else if (type === 'position') {
            searchParams.positionId = key;
            searchParams.positionName = label;
            obj.positionOptions = options;
        } else if (type === 'leader') {
            searchParams.leaderId = key;
            searchParams.leaderName = label;
            obj.leaderOptions = options;
        } else if (type === 'hospital') {
            searchParams.hospitalId = key;
            searchParams.hospitalName = label;
            obj.hospitalOptions = options;
        }
        this.setState({
            ...obj,
            searchParams,
        });
    }

    render() {
        const {
            searchParams: {
                employeeCode,
                userCompellation,
                areaName,
                hasCheckedArea = [],
                enterpriseDepartmentId,
                enterpriseDepartmentName,
                positionId,
                positionName,
                leaderId,
                leaderName,
            },
            positionOptions = [],
            leaderOptions = [],
        } = this.state;
        const departmentValue = enterpriseDepartmentId ? { key: String(enterpriseDepartmentId), label: enterpriseDepartmentName } : {};
        const positionValue = positionId ? { key: String(positionId), label: positionName } : {};
        const leaderValue = leaderId ? { key: String(leaderId), label: leaderName } : {};
        return (
            <div className="search-bar" style={{ marginBottom: 20 }}>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">工号</label>
                    <Input
                        placeholder="请输入"
                        value={employeeCode}
                        style={{ width: 120 }}
                        onChange={e => this.handleInputChange(e, 'employeeCode')}
                        onKeyPress={this.enterSearch}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">姓名</label>
                    <Input
                        placeholder="请输入"
                        style={{ width: 120 }}
                        value={userCompellation}
                        onChange={e => this.handleInputChange(e, 'userCompellation')}
                        onKeyPress={this.enterSearch}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">部门</label>
                    <SearchRetrieve
                        type="department"
                        keyword="keyword"
                        style={{ width: 142 }}
                        placeholder="输入部门检索"
                        value={departmentValue}
                        data={[{
                            text:'临床肿瘤事业部',
                            value:99
                        }, {
                            text:'临床非肿瘤事业部',
                            value:100
                        }, {
                            text:'临床综合事业部',
                            value:101
                        }, {
                            text:'临床资源部',
                            value:102
                        }, {
                            text:'临床部',
                            value:41
                        }, {
                            text:'津石医药临床部',
                            value:1
                        },  {
                            text:'药明津石临床部',
                            value:68
                        }]}
                        params={{ limit: 20 }}
                        url={API_URL.user.queryUserDepartmentSelect}
                        config={{ id: 'enterpriseDepartmentId', name: 'enterpriseDepartmentName' }}
                        onChange={this.handleChange}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">职位级别</label>
                    <SearchRetrieve
                        type="position"
                        keyword='positionName'
                        style={{ width: 142 }}
                        placeholder="输入职位检索"
                        value={positionValue}
                        data={positionOptions}
                        disabled={!enterpriseDepartmentId}
                        params={{ limit: 20, enterpriseDepartmentId }}
                        url={API_URL.team.queryUserPositionSelect}
                        config={{ id: 'positionId', name: 'positionName' }}
                        onChange={this.handleChange}
                    />
                </div>
                <div className="search-item">
                    <label className="ui-label">区域/城市</label>
                    <SelectProvince areaName={areaName} saveProvince={this.saveProvince} hasCheckedArea={hasCheckedArea} />
                </div>
                <div className="search-item">
                    <label className="ui-label">主管领导</label>
                    <SearchRetrieve
                        type="leader"
                        keyword='keyword'
                        style={{ width: 142 }}
                        placeholder="输入姓名/工号检索"
                        value={leaderValue}
                        data={leaderOptions}
                        params={{ limit: 20 }}
                        url={API_URL.user.queryEmpVitaeUserList}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                        onChange={this.handleChange}
                    />
                </div>
                <div className="search-item">
                    <Button type="primary" onClick={this.search}>搜索</Button>
                </div>
            </div>
        );
    }
}

class UserFolder extends React.Component {
    state = {
        sortParams: {},
        searchParams: {},
        pagination: {
            current: 1,
            pageSize: 10,
        },
        loading: false,
        data: [],
    }

    search = (params) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: params,
        }, () => {
            this.loadData();
        });
    }

    loadData = () => {
        const { sortParams, searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.getEmpVitaeList,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
                positionId: '',
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [], totalCount = 0 } = res;
                pagination.total = totalCount;

                this.setState({
                    pagination,
                    data: datas,
                    loading: false,
                });
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => {
        const columns = [{
            title: '工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 80,
        }, {
            title: '姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 60,
        }, {
            title: '部门',
            dataIndex: 'enterpriseDepartmentName',
            key: 'enterpriseDepartmentName',
            width: 140,
        }, {
            title: '职位/级别',
            dataIndex: 'positionName',
            key: 'positionName',
            width: 100,
        },{
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 80,
        },{
            title: '城市',
            dataIndex: 'workCity',
            key: 'workCity',
            width: 80,
        }, {
            title: '主管领导工号',
            dataIndex: 'leaderCode',
            key: 'leaderCode',
            width: 100,
        }, {
            title: '主管领导姓名',
            dataIndex: 'leaderName',
            key: 'leaderName',
            width: 80,
        }, {
            title: '状态',
            dataIndex: 'workStatus',
            key: 'workStatus',
            width: 60,
        }, {
            title: '操作',
            dataIndex: 'operate',
            key: 'operate',
            width: 80,
            fixed: 'right',
            render: (text, record) => {
                return <a onClick={() => this.showPersonalFile(record)}>查看文档</a>
            }
        }];
        return columns;
    }

    getDataSource = () => {
        const { data, pagination: { current, pageSize } } = this.state;
        const dataSource = data.map((item, index) => {
            const { workStatus } = item;
            return {
                index: (current - 1) * pageSize + index + 1,
                ...item,
                workStatus: workStatus ? (workStatus === 'WORKING' ? '在职' : "离职") : '',
            };
        });
        return dataSource;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    showPersonalFile = (record) => {
        const { userId, userCompellation } = record;
        this.props.saveParams({
            folderUserId: userId,
            folderUserName: userCompellation,
        });
        location.href = `./#/personal/file`;
    }

    showPreviewModal = userId => {
        this.previewModalRef.show(userId);
    }

    render() {
        const { loading, pagination, sortParams } = this.state;
        return (
            <div className="content">
                <UserSider selectKey='userFolder' openKeys={['sub1']}/>
                <div className='main'>
                    <Filter search={this.search}/>
                    <TableC
                        loading={loading}
                        pagination={pagination}
                        sortParams={sortParams}
                        columns={this.getColumns()}
                        data={this.getDataSource()}
                        onChange={this.handleTableChange}
                    />
                </div>
            </div>
        );
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params))
    }
}

export default connect(null, mapDispatchToProps)(UserFolder);


// WEBPACK FOOTER //
// ./src/components/user/UserFolder.js